import { render, staticRenderFns } from "./customList.vue?vue&type=template&id=0bb1ec44"
import script from "./customList.vue?vue&type=script&lang=js"
export * from "./customList.vue?vue&type=script&lang=js"
import style0 from "./customList.vue?vue&type=style&index=0&id=0bb1ec44&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports